import { Component, OnInit, Inject, PLATFORM_ID, Optional, Renderer2, InjectionToken, DestroyRef, inject, AfterViewInit, signal } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalcontentModel } from '../../../models/content/GlobalcontentModel';
import { GlobalcontentService } from '../../../services/globalcontent.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { PARTNER_TOKEN_BROWSER, REQUEST, RESPONSE } from 'browsertockens';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { GoogleService } from '@app/services/google.service';
import { PARTNER_TOKEN } from 'tockens';
import { ContenteditorComponent } from '@app/components/contenteditor/contenteditor.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
const STATE_KEY_ITEMS = makeStateKey('reisen');
const STATE_KEY_ITEMS_404 = makeStateKey('reisen404');

@Component({
    selector: 'app-reisendetail',
    templateUrl: './reisendetail.component.html',
    styleUrls: ['./reisendetail.component.scss'],
    imports: [
        ContenteditorComponent
    ]
})
export class ReisendetailComponent implements OnInit, AfterViewInit {
    currentpath: string = '/';
    currentpathname: string = '';
    partnerid: string = '';
    schema: any = {};
    reisen = signal<GlobalcontentModel>({} as GlobalcontentModel);
    show404msg = signal(false);
    destroyRef = inject(DestroyRef);
    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected metaService: Meta,
        protected titleService: Title,
        protected guardService: AuthGuardService,
        protected location: Location,
        protected globalcontentService: GlobalcontentService,
        @Inject(DOCUMENT) protected dom,
        protected _renderer2: Renderer2,
        protected googleService: GoogleService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(REQUEST) private request: any,
        protected state: TransferState,
        @Optional() @Inject(PARTNER_TOKEN) private partner_id: InjectionToken<string>,
        @Optional() @Inject(PARTNER_TOKEN_BROWSER) private bpartner_id: BehaviorSubject<string>,
        @Optional() @Inject(RESPONSE) private httpResponseData: any,
    ) {
        if (isPlatformServer(this.platformId)) {
            this.partnerid = this.partner_id.toString();
        } else {
            this.partnerid = this.bpartner_id?.getValue();
        }
        if (!this.partnerid && isPlatformBrowser(this.platformId)) {
            this.partnerid = window.localStorage.getItem('partnerid');
        }
    }

    ngOnInit(): void {
        this.reisen.set(this.state.get(STATE_KEY_ITEMS, <any>{}));
        this.checkPartner();
    }

    checkPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((res) => {
            if (res.nositemap) {
                this.metaService.updateTag({ name: 'robots', content: 'noindex,follow,max-image-preview:large,noodp,noydir' });
            } else {
                this.metaService.updateTag({ name: 'robots', content: 'index,follow,max-image-preview:large,noodp,noydir' });
            }
        });
        this.currentpath = '';
        this.currentpathname = '';
        this.currentpath += this.route.snapshot.data['path']?.length > 0 ? '/' + this.route.snapshot.data['path'] : '';
        for (let i = 0; i < this.route.snapshot.paramMap.keys.length - 1; i++) {
            if (this.route.snapshot.paramMap.keys[i] !== 'id') {
                this.currentpath += '/' + this.route.snapshot.paramMap.get(this.route.snapshot.paramMap.keys[i]);
            }
        }
        this.currentpathname = this.route.snapshot.paramMap.get(this.route.snapshot.paramMap.keys[this.route.snapshot.paramMap.keys.length - 1]);
        this.initData();
    }

    initData(): void {
        this.state.set(STATE_KEY_ITEMS, <any>{}); // remove content for next loading
        if (!this.reisen()?.elements) {
            this.globalcontentService.request({ partnerid: this.partnerid, path: this.currentpath, pathname: this.currentpathname }, 'getcontentsbypath').pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError((error: HttpErrorResponse) => {
                    return of(error)
                })
            ).subscribe((result) => {
                if (result?.result?.redirecturl?.length > 0) {
                    if (isPlatformServer(this.platformId)) {
                        this.request.res.redirect(
                            307,
                            result?.result?.redirecturl
                        );
                    }
                } else {
                    this.initRes(result?.result, result?.folder_index);
                }
            });
        } else if (this.reisen()?.elements) {
            if (isPlatformBrowser(this.platformId)) {
                this.setExtraScript(this.reisen()?.extraScript);
                this.incview(this.reisen()?.globalcontentid);
            }
        }
    }

    setNoIndex(): void {
        this.metaService.updateTag({ name: 'robots', content: 'noindex,follow,max-image-preview:large,noodp,noydir' });
    }

    initRes(res, folder_index): void {
        if (res?.active) {
            if (res?.noindex) {
                this.setNoIndex();
            }
            if (isPlatformBrowser(this.platformId)) {
                this.incview(res?.globalcontentid);
            }
            res.dateStart = res.dateStart?.length > 0 ? res.dateStart : null;
            res.dateEnd = res.dateEnd?.length > 0 ? res.dateEnd : null;
            if (res.dateStart && new Date(res.dateStart) <= new Date() &&
                res.dateEnd && new Date(res.dateEnd) >= new Date()) {
                this.reisen.set(res);
                if (isPlatformServer(this.platformId)) {
                    this.state.set(STATE_KEY_ITEMS, <any>this.reisen());
                }

                this.titleService.setTitle(this.reisen()?.meta?.title);
                this.addTags(this.reisen()?.meta, this.partnerid);
                this.setExtraScript(this.reisen()?.extraScript);
            } else if (!res.dateEnd && !res.dateStart) {
                this.reisen.set(res);
                if (isPlatformServer(this.platformId)) {
                    this.state.set(STATE_KEY_ITEMS, <any>this.reisen());
                }
                this.titleService.setTitle(this.reisen()?.meta?.title);
                this.addTags(this.reisen()?.meta, this.partnerid);
                this.setExtraScript(this.reisen()?.extraScript);
            } else {
                this.gotoAlternative(folder_index, this.partnerid);
            }
        } else {
            this.gotoAlternative(folder_index, this.partnerid);
        }
    }

    setExtraScript(extraScript: string): void {
        this.googleService.gTagIsCreated$().pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((isCreated) => {
            if (isCreated && extraScript?.length > 0) {
                const exScript = this._renderer2.createElement('script');
                exScript.text = extraScript.trim().replaceAll('\n', '').replaceAll('<script>', '').replaceAll('</script>', '');
                this._renderer2.appendChild(this.dom.body, exScript);
            }
        });
    }

    async gotostartsite() {
        this.router.navigate(['/']);
    }

    async gotoAlternative(folder_index, partnerid) {
        if (folder_index) {
            this.reisen.set(folder_index);
            const url = this.router.createUrlTree([this.currentpath + '/' + this.currentpathname], {}).toString();
            this.location.go(url);
            this.addTags(this.reisen()?.meta, partnerid);
        } else {
            if (isPlatformServer(this.platformId)) {
                this.request.res.status(404);
            }
            this.get404Site();
        }
    }

    async get404Site() {
        this.reisen.set(this.state.get(STATE_KEY_ITEMS_404, <any>{}));
        this.state.set(STATE_KEY_ITEMS_404, <any>{}); // remove content for next loading
        if (!this.reisen()?.elements) {
            this.globalcontentService.request({ partnerid: this.partnerid }, 'get404site').pipe(
                takeUntilDestroyed(this.destroyRef),
            ).subscribe((result) => {
                if (result) {
                    this.reisen.set(result);
                    if (isPlatformServer(this.platformId)) {
                        this.state.set(STATE_KEY_ITEMS_404, <any>this.reisen());
                    }
                    if (isPlatformBrowser(this.platformId)) {
                        this.incview(result?.globalcontentid);
                    }
                    this.titleService.setTitle(this.reisen()?.meta?.title);
                    this.addTags(this.reisen()?.meta, this.partnerid);
                    this.setExtraScript(this.reisen()?.extraScript);
                } else {
                    this.show404msg.set(true);
                }
            });
        } else {
            if (isPlatformBrowser(this.platformId)) {
                this.incview(this.reisen()?.globalcontentid);
            }
        }
    }

    incview(gbid): void {
        this.globalcontentService.request({ partnerid: this.partnerid, globalcontentid: gbid }, 'incview').pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((_) => { });
    }

    ngAfterViewInit(): void {
        if (this.reisen()?.scriptdata?.length > 0) {
            const cleverscript = this.dom.getElementById('clever-custom-content-script');
            if (cleverscript) {
                setTimeout(() => {
                    var newScript = this.dom.createElement("script");
                    newScript.textContent = this.reisen()?.scriptdata;
                    newScript.id = 'clever-custom-content-script';
                    this.dom.body.replaceChild(newScript, cleverscript);
                }, 100);
            }
        }
        this.scroolintoid();
    }

    async scroolintoid() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                const id = document.location.href.split('#').pop();
                if (id?.length > 0) {
                    const frg = document.getElementById(id);
                    if (frg) {
                        frg.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }, 500);
        }
    }

    addTags(metaData?, partnerid?): void {
        if (this.reisen()?.cssdata?.length > 0) {
            const cleverstyle = this.dom.getElementById('clever-custom-content-style');
            if (cleverstyle) {
                cleverstyle.innerText = this.reisen()?.cssdata?.replaceAll('\n', '');
            }
        }
        const url = new URL(this.dom.URL);
        this.metaService.updateTag({ property: 'og:title', content: this.reisen()?.meta?.title });
        this.metaService.updateTag({ name: 'url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
        this.updateCanonicalUrl(String(url.origin + url.pathname).replace(/http:/, 'https:'));
        this.metaService.updateTag({ name: 'url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
        if (metaData && partnerid?.length > 0) {
            this.schema = {
                '@context': 'http://schema.org',
                '@type': 'WebSite',
                name: metaData?.title,
                description: metaData?.description,
                keywords: metaData?.keywords,
            };
            this.globalcontentService.loadjsonld(this.schema);
            if (this.reisen()?.sdata) {
                try {
                    this.globalcontentService.loadjsonld(JSON.parse(this.reisen()?.sdata));
                } catch (error) {
                    // console.log(error)
                }
            }
            this.metaService.updateTag({ name: 'url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
            this.metaService.updateTag({ property: 'og:site_name', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
            this.metaService.updateTag({ property: 'og:url', content: String(url.origin + url.pathname).replace(/http:/, 'https:') });
            if (metaData?.description?.length > 0) {
                this.metaService.updateTag({ name: 'description', content: metaData.description });
                this.metaService.updateTag({ property: 'og:description', content: metaData.description });
            }
            if (metaData?.keywords?.length > 0) {
                this.metaService.updateTag({ name: 'keywords', content: metaData.keywords });
            }
            if (partnerid?.length > 0) {
                this.metaService.updateTag({ name: 'author', content: partnerid }); // this.globalcontent.changedby
            }
        }
    }

    updateCanonicalUrl(url: string): void {
        if (url?.length > 0) {
            const head = this.dom.getElementsByTagName('head')[0];
            let element = this.dom.querySelector('link[rel=\'canonical\']') || null;
            if (element == null) {
                element = this.dom.createElement('link');
                head.appendChild(element);
            }
            element.setAttribute('rel', 'canonical');
            element.setAttribute('href', url);
        }
    }
}
